<template>
  <cms-deploy />
</template>

<script>
export default {
  components: {
    CmsDeploy: () => import('@/components/cms/deploy/CmsDeploy'),
  },
}
</script>